var t = /* @__PURE__ */ ((r) => (r.Row = "row", r.Col = "col", r))(t || {});
const c = ["row", "col"];
var e = /* @__PURE__ */ ((r) => (r.Left = "left", r.Right = "right", r.Center = "center", r))(e || {});
const L = ["left", "right", "center"];
var n = /* @__PURE__ */ ((r) => (r.String = "string", r.Number = "number", r.Date = "date", r.Currency = "currency", r.Percent = "percent", r))(n || {});
const u = [
  "string",
  "number",
  "date",
  "currency",
  "percent"
];
export {
  u as TABLE_CELL_FORMATS,
  L as TABLE_COLUMN_ALIGN,
  c as TABLE_SCOPES,
  n as TableCellFormat,
  e as TableColumnAlign,
  t as TableScope
};
